function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.step = this.input.getAttribute("step");
      this.changeEvent = new Event("change", {
        bubbles: true,
      });
      // Create buttons
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");

      // Add functionality to buttons
      this.subtract.addEventListener("click", () =>
        this.change_quantity(-1 * this.step),
      );
      this.add.addEventListener("click", () =>
        this.change_quantity(1 * this.step),
      );
    }
    connectedCallback() {
      this.classList.add("buttons_added");
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute("min") > quantity + change) {
        return;
      }
      if (this.input.getAttribute("max")) {
        if (this.input.getAttribute("max") < quantity + change) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle("disabled", value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle("disabled", value >= max);
      }
    }
  }
  customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.swatches = this.querySelector(".product-card-swatches");
      this.image = this.querySelector(
        ".product-featured-image-link .product-primary-image",
      );
      this.additional_images = this.querySelectorAll(
        ".product-secondary-image",
      );
      this.additional_images_nav = this.querySelectorAll(
        ".product-secondary-images-nav li",
      );
      this.wishlistQuickAdd = this.querySelector(
        ".wishlist__add-to-cart button",
      );
      this.isSlider = this.querySelector(
        ".product-featured-image",
      )?.classList.contains("additional-images--slider");
      this.isWishlist =
        this.parentElement?.classList.contains("wishlist__item");
      this.wishlistSizeSelect = this.querySelector("[data-wishlist-size]");
      this.quickAddSizes = this.querySelector("[data-quick-add-sizes]");
      this.sizeOptionIndex =
        Number(
          this.querySelector("[data-variants-data]")?.dataset?.sizeOptionIndex,
        ) + 1 || null;
      this.mobileQuickAddTriggers = this.querySelectorAll(
        "[data-quick-add-mobile-trigger]",
      );
      this.variantsData = this.querySelector("[data-variants-data]")
        ? JSON.parse(this.querySelector("[data-variants-data]").innerText)
        : null;
      this.variantsPreorderData = this.querySelector(
        "[data-variants-preorder-data]",
      )
        ? JSON.parse(
            this.querySelector("[data-variants-preorder-data]").innerText,
          )
        : null;
      this.productProperties = this.querySelector("[data-product-properties]")
        ? JSON.parse(this.querySelector("[data-product-properties]").innerText)
        : null;
      if (this.variantsData && this.variantsPreorderData) {
        this.variantsData = this.variantsData.map((variant, index) => {
          return {
            ...variant,
            ...this.variantsPreorderData[index],
          };
        });
      }
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
        this.handleSwatchChange(this.swatches);
        this.initSwatchCarousel();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      this.setupHoverVideo();
      // this.enableQuickAdd();
      this.handleQuickAdd();
      this.setupProductOptions();
    }

    setupHoverVideo() {
      const video = this.querySelector(".product-card__video video");
      if (!video) return;

      // Tagalys renders search cards via its own templating, which may not
      // reflect the bare `muted` attribute to the DOM property — without it,
      // play() is rejected by the autoplay policy. No-op for Liquid cards.
      video.muted = true;

      const videoFirst = this.querySelector(
        ".product-featured-image",
      )?.classList.contains("product-featured-image--video-first");

      if (!videoFirst && window.matchMedia("(hover: hover)").matches) {
        const trigger = this.querySelector(".product-featured-image-link") || this;
        trigger.addEventListener("mouseenter", () => {
          video.play().catch(() => {});
        });
        trigger.addEventListener("mouseleave", () => {
          video.pause();
        });
      } else {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.75 },
        );
        observer.observe(video);
      }
    }

    setupProductOptions() {
      const inputs = [...(this.quickAddSizes?.querySelectorAll("input") ?? [])];
      const labels = [...(this.quickAddSizes?.querySelectorAll("label") ?? [])];

      inputs.forEach((input) => {
        const id = input.getAttribute("id");
        const size = input.getAttribute("value");
        const matchedVariant = this.variantsData.find(
          (variant) => variant[`option${this.sizeOptionIndex}`] === size,
        );
        if (!matchedVariant) return;
        // Enrich input with variant variant price
        input.setAttribute("data-option-price", matchedVariant.price);
        // Handle Unavailable options
        const matchingInput = inputs.find(
          (input) => input.getAttribute("id") === id,
        );
        if (!matchedVariant.available) {
          matchingInput.disabled = true;
        } else {
          matchingInput.dataset.selectedVariantId = matchedVariant.id;
          matchingInput.addEventListener("change", this.quickAdd.bind(this));
        }
      });
    }

    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector(".product-featured-image");

      if (this.isSlider) {
        this.initialiseSlider();
        const _this = this;
        window.addEventListener(
          "resize",
          debounce(function () {
            _this.initialiseSlider();
          }, 100),
        );
      } else {
        const mousemove = function (e) {
          let l = e.offsetX;
          let w = this.getBoundingClientRect().width;
          let prc = l / w;
          let sel = Math.floor(prc * image_length);
          let selimg = images[sel];
          images.forEach((image, index) => {
            if (image.classList.contains("hover")) {
              image.classList.remove("hover");
              if (nav.length) {
                nav[index].classList.remove("active");
              }
            }
          });
          if (selimg) {
            if (!selimg.classList.contains("hover")) {
              selimg.classList.add("hover");
              if (nav.length) {
                nav[sel].classList.add("active");
              }
            }
          }
        };
        const mouseleave = function (e) {
          images.forEach((image, index) => {
            image.classList.remove("hover");
            if (nav.length) {
              nav[index].classList.remove("active");
            }
          });
        };
        if (image_container) {
          image_container.addEventListener("touchstart", mousemove, {
            passive: true,
          });
          image_container.addEventListener("touchmove", mousemove, {
            passive: true,
          });
          image_container.addEventListener("touchend", mouseleave, {
            passive: true,
          });
          image_container.addEventListener("mouseenter", mousemove, {
            passive: true,
          });
          image_container.addEventListener("mousemove", mousemove, {
            passive: true,
          });
          image_container.addEventListener("mouseleave", mouseleave, {
            passive: true,
          });
        }
      }

      images.forEach(function (image) {
        window.addEventListener("load", (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }

    initialiseSlider() {
      const sliderElement = this.querySelector(".product-featured-image-link");
      const scrollDistance = sliderElement.offsetWidth;
      const scrollForwardButton = this.querySelector(
        ".product-card-slider__button--forward",
      );
      const scrollBackButton = this.querySelector(
        ".product-card-slider__button--back",
      );
      if (!scrollForwardButton || !scrollBackButton) return;
      // Handle Back & Fwd Scrolling buttons
      scrollForwardButton.addEventListener(
        "click",
        () => (sliderElement.scrollLeft += scrollDistance),
      );
      scrollBackButton.addEventListener(
        "click",
        () => (sliderElement.scrollLeft -= scrollDistance),
      );
    }

    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = image ? image.dataset.srcset : "";

      swatch_list.forEach((swatch, index) => {
        window.addEventListener("load", (event) => {
          if (swatch.dataset.srcset) {
            let image = new Image();
            image.srcset = swatch.dataset.srcset;
            lazySizes.loader.unveil(image);
          }
        });
      });
    }

    initSwatchCarousel() {
      const swatchCarousel = this.querySelector("[data-swatch-carousel]");
      if (!swatchCarousel) return;

      // Check if Flickity is already initialized
      if (Flickity.data(swatchCarousel)) return;

      const wrapper = swatchCarousel.parentElement;
      const prev_button = wrapper.querySelector(".flickity-prev");
      const next_button = wrapper.querySelector(".flickity-next");

      const args = {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        groupCells: true,
        draggable: true,
        freeScroll: false,
        wrapAround: false,
        on: {
          ready() {
            if (prev_button) {
              prev_button.classList.add("disabled");
            }
          },
          change() {
            if (!prev_button || !next_button) return;

            // Check if at the beginning
            if (this.selectedIndex === 0) {
              prev_button.classList.add("disabled");
              next_button.classList.remove("disabled");
            }
            // Check if at the end
            else if (this.selectedIndex >= this.slides.length - 1) {
              prev_button.classList.remove("disabled");
              next_button.classList.add("disabled");
            }
            // In the middle
            else {
              prev_button.classList.remove("disabled");
              next_button.classList.remove("disabled");
            }
          },
        },
      };

      this.swatchFlickity = new Flickity(swatchCarousel, args);

      // Flickity locks the viewport to the cell positions/height measured at
      // init. When the card's CSS lands after init (e.g. a section whose styles
      // load async via vite-tag), that measurement is stale and the swatches
      // get cropped until a manual resize. Re-measure once layout has settled
      // — across the next frames, after fonts load, and on window load — so the
      // carousel self-heals without the user resizing.
      const resizeSwatches = () => {
        if (this.swatchFlickity) this.swatchFlickity.resize();
      };
      requestAnimationFrame(() => requestAnimationFrame(resizeSwatches));
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(resizeSwatches);
      }
      if (document.readyState !== "complete") {
        window.addEventListener("load", resizeSwatches, { once: true });
      }

      // Add click handlers for navigation buttons
      if (prev_button) {
        prev_button.addEventListener("click", (event) => {
          event.preventDefault();
          this.swatchFlickity.previous();
        });
      }
      if (next_button) {
        next_button.addEventListener("click", (event) => {
          event.preventDefault();
          this.swatchFlickity.next();
        });
      }
    }

    handleSwatchChange(swatches) {
      if (!swatches) return;

      swatches.addEventListener("click", async (evt) => {
        const swatch = evt.target.closest(".product-card-swatch");
        if (!swatch) return;

        evt.preventDefault();

        if (swatch.classList.contains("product-card-swatch--active")) return;

        const url = new URL(swatch.href);
        url.searchParams.set("view", "card");

        try {
          const response = await fetch(url.toString());
          const html = await response.text();

          const parser = new DOMParser();
          const newCard = parser
            .parseFromString(html, "text/html")
            .querySelector(".product-card");
          const oldCard = this;

          if (newCard && oldCard) {
            oldCard.replaceWith(newCard);
          }
        } catch (error) {
          console.error(error);
        }
      });
    }

    handleQuickAdd() {
      if (this.isWishlist) {
        const quickAddButton = this.wishlistQuickAdd;
        const dataElement = this.querySelector(".wishlist__add-to-cart script");
        const parsedPreorderData = this.variantsPreorderData;

        // handle updating variants via Select element
        this.wishlistSizeSelect.addEventListener("change", function (e) {
          const size = e.target.value;
          const sizeIndex = Number(dataElement.dataset.sizeOptionIndex) + 1;
          if (!dataElement) return;
          let parsedData = JSON.parse(dataElement.innerHTML);
          if (parsedPreorderData) {
            parsedData = parsedData.map((variant, index) => {
              return {
                ...variant,
                ...parsedPreorderData[index],
              };
            });
          }
          const matchedVariant = parsedData.find(
            (variant) => variant[`option${sizeIndex}`] === size,
          );
          if (!matchedVariant) return;
          if (matchedVariant.available) {
            // enable QuickAdd button
            const label = matchedVariant.made_to_order
              ? quickAddButton.dataset.madeToOrderLabel
              : matchedVariant.preorder
                ? quickAddButton.dataset.preorderLabel
                : quickAddButton.dataset.addLabel;
            quickAddButton.dataset.selectedVariantId = matchedVariant.id;
            quickAddButton.disabled = false;
            quickAddButton.innerHTML = label;
          } else {
            // disable QuickAdd button
            const label = quickAddButton.dataset.soldOutLabel;
            quickAddButton.dataset.selectedVariantId = "";
            quickAddButton.disabled = true;
            quickAddButton.innerHTML = label;
          }
        });

        quickAddButton.addEventListener("click", this.quickAdd.bind(this));
        // handle add to cart
      } else {
        const modal = document.querySelector("[data-collection-modal]");
        if (!modal) return;

        const modalClose = modal.querySelector("[data-close-modal]");
        const modalContents = modal.querySelector("[data-modal-contents]");

        document.addEventListener("cart:item-added", () => modal.close());
        modalClose.addEventListener("click", () => modal.close());

        // Handle click outside open modal
        modal.addEventListener("click", (e) => {
          const dialogDimensions = modal.getBoundingClientRect();
          const isClickOutside = !(
            e.clientX >= dialogDimensions.left &&
            e.clientX <= dialogDimensions.right &&
            e.clientY >= dialogDimensions.top &&
            e.clientY <= dialogDimensions.bottom
          );
          if (isClickOutside) modal.close();
        });

        this.mobileQuickAddTriggers.forEach((trigger) => {
          // Handle updating Mobile Options Modal with Relevant options
          trigger.addEventListener("click", (e) => {
            const swatches = trigger.nextElementSibling.cloneNode(true);
            const inputs = swatches.querySelectorAll("input");
            const labels = swatches.querySelectorAll("label");

            inputs.forEach((input) => {
              input.removeAttribute("checked");
              input.id = input.id + "-modal";
            });
            labels.forEach((label) => {
              label.removeAttribute("data-quickadd-option");
              label.setAttribute("for", label.getAttribute("for") + "-modal");
            });
            modalContents.innerHTML = swatches.outerHTML;
            modalContents.insertAdjacentHTML(
              "afterbegin",
              `<h3>choose your size</h3>`,
            );
            modalContents.insertAdjacentHTML(
              "beforeend",
              `<button class="button button--block" data-quickadd-button disabled>
                <span data-cta-label>Select a size</span>
                <span data-cta-price></span>
              </button>`,
            );

            const productSummary = modalContents.querySelector(
              ".product-card__quick-add-product-summary",
            );
            if (productSummary) {
              modalContents.prepend(productSummary);
            }

            const insertedInputs = modalContents.querySelectorAll("input");

            const quickAddButton = modalContents.querySelector(
              "[data-quickadd-button]",
            );
            const quickAddButtonPrice =
              quickAddButton.querySelector("[data-cta-price]");
            const quickAddButtonLabel =
              quickAddButton.querySelector("[data-cta-label]");

            // Handle input selection
            insertedInputs.forEach((input) => {
              input.addEventListener("change", (e) => {
                const size = e.target.value;
                const format =
                  window.theme.settings.money_with_currency_format ||
                  "${{amount}}";
                const matchedVariant = this.variantsData.find(
                  (variant) =>
                    variant[`option${this.sizeOptionIndex}`] === size,
                );
                if (!matchedVariant) return;
                if (matchedVariant.available) {
                  // enable QuickAdd button
                  const ctaText = matchedVariant.made_to_order
                    ? window.theme.variantStrings.madeToOrder
                    : matchedVariant.preorder
                      ? window.theme.variantStrings.preorder
                      : window.theme.variantStrings.addToCart;
                  quickAddButton.dataset.selectedVariantId = matchedVariant.id;
                  quickAddButton.disabled = false;
                  quickAddButtonLabel.innerHTML = ctaText;
                  quickAddButtonPrice.innerHTML = `
                    <span data-price-to-convert>
                      ${formatMoney(matchedVariant.price, format)}
                    </span>
                  `;

                  // Update preorder/MTO message
                  const existingMessage = modalContents.querySelector(
                    "[data-modal-preorder-message]",
                  );

                  if (matchedVariant.selling_plan_description) {
                    if (existingMessage) {
                      existingMessage.textContent =
                        matchedVariant.selling_plan_description;
                    } else {
                      const messageEl = document.createElement("div");
                      messageEl.className = "product-preorder-message";
                      messageEl.setAttribute("data-modal-preorder-message", "");
                      messageEl.textContent =
                        matchedVariant.selling_plan_description;
                      quickAddButton.insertAdjacentElement(
                        "afterend",
                        messageEl,
                      );
                    }
                  } else {
                    if (existingMessage) {
                      existingMessage.remove();
                    }
                  }

                  window.Currency?.convertAll?.();
                }
              });
            });

            // Handle Add to cart
            quickAddButton.addEventListener("click", this.quickAdd.bind(this));

            modal.showModal();
          });
        });
      }
    }

    quickAdd(evt) {
      evt.preventDefault();
      const { target } = evt;
      const selectedVariantId = evt.target.dataset.selectedVariantId;
      const wishlistItem = target.closest(".wishlist__item");

      const preorderData = this.variantsPreorderData?.find(
        (variant) => Number(variant.id) === Number(selectedVariantId),
      );
      const isPreorder = preorderData?.preorder;
      const isMadeToOrder = preorderData?.made_to_order;
      const sellingPlanId = preorderData?.selling_plan_id;
      const fulfilmentDate = preorderData?.fulfilment_date ?? true;
      const submarineCampaignName = preorderData?.submarine_campaign_name;
      const mtoStyle = preorderData?.mto_style;

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData();

      formData.append("id", selectedVariantId);
      formData.append("quantity", 1);
      if (isPreorder && sellingPlanId) {
        formData.append("selling_plan", sellingPlanId);
        formData.append(
          isMadeToOrder
            ? "properties[_made_to_order]"
            : "properties[_pre_order]",
          fulfilmentDate,
        );
        if (submarineCampaignName) {
          formData.append(
            isMadeToOrder
              ? "properties[_made_to_order_campaign_name]"
              : "properties[_pre_order_campaign_name]",
            submarineCampaignName,
          );
        }
        if (mtoStyle) {
          formData.append("properties[_mto_style]", mtoStyle);
        }
      }
      if (this.productProperties) {
        this.productProperties.forEach(({ key, value }) => {
          formData.append(`properties[${key}]`, value);
        });
      }
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section),
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      // Handle loading states
      const originalButtonContent = evt.target.innerHTML;
      const closestParentCard = evt.target.closest(".product-card");
      const isTriggeredFromButton =
        "quickaddButton" in evt.target.dataset ||
        "quickaddWishlist" in evt.target.dataset;
      if (isTriggeredFromButton) {
        evt.target.innerHTML = `<span>Adding...</span>`;
      } else {
        closestParentCard?.classList.add("u-loading");
      }
      // Send data
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });

          if (isTriggeredFromButton) {
            evt.target.innerHTML = originalButtonContent;
          } else {
            closestParentCard.classList.remove("u-loading");
          }

          this.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
          if (isTriggeredFromButton) {
            evt.target.innerHTML = originalButtonContent;
          } else {
            closestParentCard.classList.remove("u-loading");
          }
        })
        .finally(() => {
          if (wishlistItem) {
            const wishlistItemAddedToCart = new CustomEvent(
              "wishlist:item-added-to-cart",
              {
                detail: {
                  wishlistItem,
                },
              },
            );
            document.dispatchEvent(wishlistItemAddedToCart);
          }
        });

      return false;
    }

    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        const newHtml = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector,
        );
        elementToReplace.innerHTML = newHtml;
        if (section.selector === ".thb-item-count") {
          elementToReplace.dataset.count = parseInt(newHtml);
        }
      });

      if (typeof CartDrawer !== "undefined") {
        new CartDrawer();
      }
      if (typeof Cart !== "undefined") {
        new Cart().renderContents(parsedState);
      }

      if (document.getElementById("Cart-Drawer")) {
        document.getElementById("Cart-Drawer").classList.add("active");
        document.body.classList.add("open-cart");
        document.body.classList.add("open-cc");
        if (
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
        ) {
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
        dispatchCustomEvent("cart-drawer:open");
      }

      const cartEvent = new CustomEvent("cartChanged");
      document.dispatchEvent(cartEvent);
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define("product-card", ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector(".header-section"),
      header_main = document.getElementById("header"),
      menu = document.getElementById("mobile-menu"),
      toggle = document.querySelector(".mobile-toggle-wrapper"),
      mobileClose = document.querySelector("[data-mobile-menu-close]"),
      announcementBar = document.querySelector(".announcement-bar-section"),
      setAnnouncementHeight = this.setAnnouncementHeight,
      setProperties = this.setProperties;

    if (!header_main) {
      return;
    }
    document.addEventListener("keyup", (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === "ESCAPE") {
          toggle.removeAttribute("open");
          toggle.classList.remove("active");
        }
      }
    });
    toggle.querySelector(".mobile-toggle").addEventListener("click", (e) => {
      if (toggle.classList.contains("active")) {
        e.preventDefault();
        document.body.classList.remove("overflow-hidden");
        toggle.classList.remove("active");
        this.closeAnimation(toggle);
      } else {
        document.body.classList.add("overflow-hidden");
        header.classList.remove("is-off-screen");
        header_main.classList.add("is-sticky");
        setTimeout(() => {
          toggle.classList.add("active");
        });
      }
      window.dispatchEvent(new Event("resize.resize-select"));
    });

    mobileClose.addEventListener("click", (e) => {
      e.preventDefault();
      document.body.classList.remove("overflow-hidden");
      toggle.classList.remove("active");
      this.closeAnimation(toggle);
    });

    // Mobile Menu offset
    let lastScrollTop = 0;
    window.addEventListener(
      "scroll",
      function () {
        const scrollTop = window.scrollY;
        const offset = parseInt(header_main.getBoundingClientRect().top, 10);

        const isSticky = scrollTop > 0 && offset <= 0;
        const isOffScreen = scrollTop > header_main.clientHeight;
        const scrolledDown = scrollTop > lastScrollTop;

        header.classList.toggle("is-off-screen", isOffScreen && scrolledDown);
        header_main.classList.toggle("is-sticky", isSticky);

        setProperties(header_main, isOffScreen && scrolledDown);
        if (announcementBar) {
          setAnnouncementHeight(announcementBar, isSticky);
        }

        lastScrollTop = scrollTop;
      },
      {
        passive: true,
      },
    );
    window.dispatchEvent(new Event("scroll"));

    document.addEventListener("search:open", () => {
      header.classList.remove("is-off-screen");
      header_main.classList.add("is-sticky");
    });
    document.addEventListener("cart-drawer:open", () => {
      header.classList.remove("is-off-screen");
      header_main.classList.add("is-sticky");
    });

    if (announcementBar) {
      window.addEventListener(
        "resize",
        function () {
          setAnnouncementHeight(announcementBar);
        },
        {
          passive: true,
        },
      );
      window.dispatchEvent(new Event("resize"));
    }
    // Buttons.
    menu
      .querySelectorAll("summary")
      .forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this)),
      );
    menu
      .querySelectorAll("button")
      .forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this)),
      );
  }
  setAnnouncementHeight(a_bar, isOffScreen) {
    let h = a_bar?.clientHeight ?? 0;
    if (isOffScreen) {
      h = 0;
    }
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${h}px`,
    );
  }
  setProperties(header, isHidden) {
    let h = header.clientHeight;

    if (isHidden) {
      document.documentElement.style.setProperty(
        "--header-offset",
        `-${h + 1}px`,
      );
      document.documentElement.style.setProperty("--header-height", "0px");
    } else {
      document.documentElement.style.setProperty("--header-offset", "0px");
      document.documentElement.style.setProperty("--header-height", `${h}px`);
    }

    const headerTop = Math.max(0, header.getBoundingClientRect().top);
    document.documentElement.style.setProperty(
      "--header-top",
      `${headerTop}px`,
    );
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".link-container");
    const isOpen = detailsElement.hasAttribute("open");

    setTimeout(() => {
      detailsElement.classList.add("menu-opening");
      parentMenuElement && parentMenuElement.classList.add("submenu-open");
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        detailsElement.querySelectorAll("details").forEach((details) => {
          details.removeAttribute("open");
          details.classList.remove("menu-opening");
          details.classList.remove("submenu-open");
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu",
      );

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        "resize",
        debounce(function () {
          _this.resizeSubMenus();
        }, 100),
      );

      window.dispatchEvent(new Event("resize"));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu",
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.parentElement.getBoundingClientRect()
                .left +
              sub_submenu.parentElement.parentElement.clientWidth +
              10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get("side-panel-close")) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
      let cc = document.querySelector(".click-capture");

      // Add functionality to buttons
      this.addEventListener("click", (e) => this.close_panel(e));
      document.addEventListener("panel:close", (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener("click", (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest(".side-panel");

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains("product-drawer")) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains("cart-drawer")) {
        if (panel.querySelector(".product-recommendations--full")) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel
              .querySelector(".product-recommendations--full")
              .classList.remove("active");
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector(".product-recommendations--full")) {
            if (!document.body.classList.contains("open-quick-view")) {
              setTimeout(() => {
                panel.classList.remove("active");
                document.body.classList.remove("open-cc");
                document.body.classList.remove("open-cart");
              }, 50);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          }
        }
      } else {
        panel.classList.remove("active");
        document.body.classList.remove("open-cc");
        document.body.classList.remove("open-search");
        const searchInput = document.querySelector("#side-panel-search-input");
        if (searchInput) {
          searchInput.value = "";
        }
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById("Product-Drawer");

      if (panel.querySelector(".product-quick-images--container")) {
        panel
          .querySelector(".product-quick-images--container")
          .classList.remove("active");
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove("active");
        if (!document.body.classList.contains("open-cart")) {
          document.body.classList.remove("open-cc");
        }
        document.body.classList.remove("open-quick-view");
      } else {
        if (panel.querySelector(".product-quick-images--container")) {
          setTimeout(() => {
            panel.classList.remove("active");
            if (!document.body.classList.contains("open-cart")) {
              document.body.classList.remove("open-cc");
            }
            document.body.classList.remove("open-quick-view");
            panel.querySelector("#Product-Drawer-Content").innerHTML = "";
          }, 500);
        }
      }
    }
  }
  customElements.define("side-panel-close", PanelClose);

  document.addEventListener("keyup", (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === "ESCAPE") {
        dispatchCustomEvent("panel:close");
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    document.addEventListener("search:open", () => {
      this.closeCart();
    });

    this.container = document.getElementById("Cart-Drawer");

    if (!this.container) {
      return;
    }

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    if (!this.container.dataset.onChangeInitialised) {
      const button = document.getElementById("cart-drawer-toggle");
      const disableCartToggle =
        button && button.dataset
          ? button.dataset.disableToggle === "true"
          : false;
      // Add functionality to buttons
      if (!disableCartToggle) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggleCart();
        });
      }

      this.container.addEventListener(
        "change",
        this.debouncedOnChange.bind(this),
      );
    }
    this.container.dataset.onChangeInitialised = true;

    this.gwpEnabled = window.theme.settings.gwp_enabled || false;
    if (this.gwpEnabled) {
      this.gwpThreshold = parseInt(window.theme.settings.gwp_threshold, 10);
      this.cartTotalElement = this.container.querySelector(
        ".side-panel-content",
      );
    }

    this.notesToggle();
    this.removeProductEvent();
    this.validateCart();
    this.updateFreeShipping();
    window.Currency?.convertAll?.();
    this.termsCheckbox();

    document.addEventListener("loyalty-gwp:added", (event) => {
      this.applyCartResponse(event.detail?.response);
    });
  }

  openCart() {
    document.body.classList.add("open-cart", "open-cc");
    this.container.classList.add("active");
    this.container.focus();
    setTimeout(() => {
      if (this.container.querySelector(".product-recommendations--full")) {
        this.container
          .querySelector(".product-recommendations--full")
          .classList.add("active");
      }
    });
    dispatchCustomEvent("cart-drawer:open");
  }

  closeCart() {
    document.body.classList.remove("open-cart");
    this.container.classList.remove("active");

    if (!document.body.classList.contains("open-search")) {
      document.body.classList.remove("open-cc");
    }
  }

  toggleCart() {
    if (document.body.classList.contains("open-cart")) {
      this.closeCart();
    } else {
      this.openCart();
    }
  }

  onChange(event) {
    if (event.target.classList.contains("qty")) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.hasAttribute("data-cart-item-options")) {
      this.updateVariant(
        event.target.dataset.index,
        event.target.value,
        event.target.querySelector("option:checked")?.dataset.sellingPlanId,
        event.target.querySelector("option:checked")?.dataset
          .submarineCampaignName,
        event.target.querySelector("option:checked")?.dataset.lineItemProperty,
        event.target.querySelector("option:checked")?.dataset.fulfilmentDate,
        event.target.querySelector("option:checked")?.dataset.mtoStyle,
      );
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll(".remove");

    removes.forEach((remove) => {
      remove.addEventListener("click", (event) => {
        const gwpItemKey = event.target.dataset.gwpItemKey || null;
        this.updateQuantity(event.target.dataset.index, "0", gwpItemKey);

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector("#CartDrawerTerms"),
      checkout_button = this.container.querySelector(".button.checkout");

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener("click", function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById("order-note-toggle");

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener("click", (event) => {
      notes_toggle.nextElementSibling.classList.add("active");
    });
    notes_toggle.nextElementSibling
      .querySelectorAll(".button, .order-note-toggle__content-overlay")
      .forEach((el) => {
        el.addEventListener("click", (event) => {
          notes_toggle.nextElementSibling.classList.remove("active");
          this.saveNotes();
        });
      });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify({
        note: document.getElementById("mini-cart__notes").value,
      }),
    });
  }
  updateFreeShipping() {
    const free_shipping = this.container.querySelector(".free-shipping");

    if (free_shipping) {
      let amount_text = free_shipping.querySelector(
        ".free-shipping--text span",
      );
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(
        parseInt(free_shipping.dataset.minimum, 10) *
          (Shopify.currency.rate || 1),
      );
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format =
              window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty("--percentage", percentage);
    }
  }
  updateQuantity(line, quantity, gwpItemKey = null) {
    this.container
      .querySelector(`#CartDrawerItem-${line}`)
      .classList.add("thb-loading");
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    if (gwpItemKey !== null) {
      localStorage.setItem("optedOutFreeProduct", "true");
    }

    if (this.container.querySelector(".product-recommendations--full")) {
      this.container
        .querySelector(".product-recommendations--full")
        .classList.remove("active");
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          if (parsedState.sections) {
            const newHtml = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            );
            elementToReplace.innerHTML = newHtml;
            if (section.selector === ".thb-item-count") {
              elementToReplace.dataset.count = parseInt(newHtml);
            }
          }
        });

        // if cart total drops below threshold revert localstorage opt out
        if (this.gwpEnabled && parsedState.total_price < this.gwpThreshold) {
          localStorage.setItem("optedOutFreeProduct", "false");
        }

        this.validateCart();
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        window.Currency?.convertAll?.();

        dispatchCustomEvent("line-item:change:end", {
          quantity: quantity,
          cart: parsedState,
        });

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container
            .querySelector(`#CartDrawerItem-${line}`)
            .classList.remove("thb-loading");
        }
      });
  }

  updateVariant(
    line,
    newVariantId,
    sellingPlanId = null,
    submarineCampaignName = null,
    lineItemProperty = null,
    fulfilmentDate = true,
    mtoStyle = null,
  ) {
    // Get the current quantity
    let lineElement = this.container.querySelector(`#CartDrawerItem-${line}`);
    let quantityElement = lineElement.querySelector(".quantity input");
    let quantity = parseInt(quantityElement.value) || 1;
    this.container
      .querySelector(`#CartDrawerItem-${line}`)
      .classList.add("thb-loading");

    const config = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
    };

    let formData = new FormData();

    formData.append("id", newVariantId);
    formData.append("quantity", quantity);
    if (sellingPlanId) {
      formData.append("selling_plan", sellingPlanId);
    }
    if (lineItemProperty) {
      formData.append(`properties[${lineItemProperty}]`, fulfilmentDate);
      if (submarineCampaignName) {
        formData.append(
          `properties[${lineItemProperty}_campaign_name]`,
          submarineCampaignName,
        );
      }
    }
    if (mtoStyle) {
      formData.append("properties[_mto_style]", mtoStyle);
    }
    formData.append(
      "sections",
      this.getSectionsToRender().map((section) => section.section),
    );
    formData.append("sections_url", window.location.pathname);

    config.body = formData;

    dispatchCustomEvent("line-item:add:start", {
      variantId: newVariantId,
    });

    fetch(`${theme.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) return;

        dispatchCustomEvent("cart:item-added", {
          product: response.hasOwnProperty("items")
            ? response.items[0]
            : response,
        });

        const removeBody = JSON.stringify({
          line: Number(line) + 1,
          quantity: 0,
          sections: this.getSectionsToRender().map(
            (section) => section.section,
          ),
          sections_url: window.location.pathname,
        });

        fetch(`${theme.routes.cart_change_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
          },
          ...{
            body: removeBody,
          },
        })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);

              if (parsedState.sections) {
                const newHtml = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector,
                );
                elementToReplace.innerHTML = newHtml;
                if (section.selector === ".thb-item-count") {
                  elementToReplace.dataset.count = parseInt(newHtml);
                }
              }
            });

            this.removeProductEvent();
            this.validateCart();
            this.notesToggle();
            this.termsCheckbox();
            this.updateFreeShipping();
            window.Currency?.convertAll?.();
            dispatchCustomEvent("line-item:change:end", {
              quantity: quantity,
              cart: parsedState,
            });

            if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
              this.container
                .querySelector(`#CartDrawerItem-${line}`)
                .classList.remove("thb-loading");
            }
          });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  async validateCart() {
    try {
      const response = await fetch(`${theme.routes.cart_url}.js`);
      const data = await response.json();
      await this.checkPreorders(data);
      this.checkGiftProduct(data);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async checkPreorders(cart) {
    const cartHasPreorderAttribute =
      cart.attributes && "preorder" in cart.attributes;
    const cartHasMadeToOrderAttribute =
      cart.attributes && "made-to-order" in cart.attributes;

    const preorderItems = cart.items.filter(
      (item) => item.properties && "_pre_order" in item.properties,
    );
    const madeToOrderItems = cart.items.filter(
      (item) => item.properties && "_made_to_order" in item.properties,
    );

    const attributes = {};

    if (cartHasPreorderAttribute && preorderItems.length === 0) {
      attributes.preorder = null;
    } else if (!cartHasPreorderAttribute && preorderItems.length > 0) {
      const fulfilmentDates = preorderItems.map((item) => {
        const fulfilmentDate = item.properties._pre_order;
        const [day, month, year] = fulfilmentDate.split("-");
        return Number(`${year}${month}${day}`);
      });
      const latestFulfilmentDateIndex = fulfilmentDates.indexOf(
        Math.max(...fulfilmentDates),
      );
      const latestFulfilmentDate =
        latestFulfilmentDateIndex > -1
          ? preorderItems[latestFulfilmentDateIndex].properties._pre_order
          : true;
      attributes.preorder = latestFulfilmentDate;
    }

    if (cartHasMadeToOrderAttribute && madeToOrderItems.length === 0) {
      attributes["made-to-order"] = null;
    } else if (!cartHasMadeToOrderAttribute && madeToOrderItems.length > 0) {
      const fulfilmentDates = madeToOrderItems.map((item) => {
        const fulfilmentDate = item.properties._made_to_order;
        const [day, month, year] = fulfilmentDate.split("-");
        return Number(`${year}${month}${day}`);
      });
      const latestFulfilmentDateIndex = fulfilmentDates.indexOf(
        Math.max(...fulfilmentDates),
      );
      const latestFulfilmentDate =
        latestFulfilmentDateIndex > -1
          ? madeToOrderItems[latestFulfilmentDateIndex].properties
              ._made_to_order
          : true;
      attributes["made-to-order"] = latestFulfilmentDate;
    }

    if (Object.keys(attributes).length === 0) {
      return;
    }

    await fetch(theme.routes.cart_update_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes }),
    });
  }

  checkGiftProduct(cart) {
    if (!this.gwpEnabled) return;

    const addFreeGiftButton = this.container.querySelector(
      "[data-add-gwp-product]",
    );
    if (addFreeGiftButton) {
      addFreeGiftButton.addEventListener("click", () => {
        const productId = addFreeGiftButton.dataset.addGwpProduct;
        this.addGwpProductToCart(productId);
      });
    }

    const gwpProductVariantId = window.theme.settings.gwp_product_variant_id;
    if (!gwpProductVariantId) return;

    const giftItem = cart.items.find((item) => item.properties._gwp === "true");
    const cartTotal = cart.total_price;

    if (cartTotal >= this.gwpThreshold) {
      const gwpProductUnlocked = this.container.querySelector(
        ".product-cart-item--gwp-unlocked",
      );
      if (
        gwpProductUnlocked &&
        localStorage.getItem("optedOutFreeProduct") === "true"
      ) {
        gwpProductUnlocked.style.display = "";
      }

      if (localStorage.getItem("optedOutFreeProduct") === "true" || giftItem)
        return;

      // Add gift product to cart
      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
      };

      let formData = new FormData();

      formData.append("id", gwpProductVariantId);
      formData.append("quantity", 1);
      formData.append("properties[_gwp]", "true");
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section),
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      dispatchCustomEvent("line-item:add:start", {
        variantId: gwpProductVariantId,
      });

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            if (response.sections) {
              const newHtml = this.getSectionInnerHTML(
                response.sections[section.section],
                section.selector,
              );
              elementToReplace.innerHTML = newHtml;
              if (section.selector === ".thb-item-count") {
                elementToReplace.dataset.count = parseInt(newHtml);
              }
            }
          });

          this.removeProductEvent();
          this.notesToggle();
          this.termsCheckbox();
          this.updateFreeShipping();
          window.Currency?.convertAll?.();

          dispatchCustomEvent("line-item:change:end", {
            variantId: gwpProductVariantId,
            cart: response,
          });
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      if (!giftItem) return;

      const body = JSON.stringify({
        id: giftItem.key,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      // Remove gift product from cart
      fetch(`${theme.routes.cart_change_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        ...{
          body,
        },
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            if (parsedState.sections) {
              const newHtml = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              );
              elementToReplace.innerHTML = newHtml;
              if (section.selector === ".thb-item-count") {
                elementToReplace.dataset.count = parseInt(newHtml);
              }
            }
          });
          this.removeProductEvent();
          this.notesToggle();
          this.termsCheckbox();
          this.updateFreeShipping();
          window.Currency?.convertAll?.();
          dispatchCustomEvent("line-item:change:end", {
            quantity: 0,
            cart: parsedState,
          });
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  addGwpProductToCart(variantId) {
    const gwpProductUnlocked = this.container.querySelector(
      ".product-cart-item--gwp-unlocked",
    );
    if (gwpProductUnlocked) {
      gwpProductUnlocked.classList.add("thb-loading");
    }
    // Add product to cart
    const config = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
    };

    let formData = new FormData();

    formData.append("id", variantId);
    formData.append("quantity", 1);
    formData.append("properties[_gwp]", "true");
    formData.append(
      "sections",
      this.getSectionsToRender().map((section) => section.section),
    );
    formData.append("sections_url", window.location.pathname);

    config.body = formData;

    dispatchCustomEvent("line-item:add:start", {
      variantId: variantId,
    });

    fetch(`${theme.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (gwpProductUnlocked) {
          gwpProductUnlocked.classList.add("thb-loading");
        }

        if (response.status) return;

        dispatchCustomEvent("cart:item-added", {
          product: response.hasOwnProperty("items")
            ? response.items[0]
            : response,
        });

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          if (response.sections) {
            const newHtml = this.getSectionInnerHTML(
              response.sections[section.section],
              section.selector,
            );
            elementToReplace.innerHTML = newHtml;
            if (section.selector === ".thb-item-count") {
              elementToReplace.dataset.count = parseInt(newHtml);
            }
          }
        });

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        window.Currency?.convertAll?.();

        dispatchCustomEvent("line-item:change:end", {
          variantId: variantId,
          cart: response,
        });
      })
      .catch((e) => {
        if (gwpProductUnlocked) {
          gwpProductUnlocked.classList.remove("thb-loading");
        }
        console.error(e);
      });
  }

  applyCartResponse(response) {
    if (!response || !response.sections) return;
    this.getSectionsToRender().forEach((section) => {
      const host = document.getElementById(section.id);
      if (!host) return;
      const target = host.querySelector(section.selector) || host;
      if (!response.sections[section.section]) return;
      const newHtml = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector,
      );
      target.innerHTML = newHtml;
      if (section.selector === ".thb-item-count") {
        target.dataset.count = parseInt(newHtml);
      }
    });
    this.removeProductEvent();
    this.notesToggle();
    this.termsCheckbox();
    this.updateFreeShipping();
    window.Currency?.convertAll?.();
  }
}

/**
 *  @class
 *  @function LoyaltyGwp
 */
class LoyaltyGwp extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector("[data-loyalty-gwp-toggle]");
    this.panel = this.querySelector("[data-loyalty-gwp-panel]");
    this.radios = this.querySelectorAll("[data-loyalty-gwp-radio]");
    this.chooseBtn = this.querySelector("[data-loyalty-gwp-choose]");
    this.dismissBtn = this.querySelector("[data-loyalty-gwp-dismiss]");

    if (this.toggle && !this.hasAttribute("data-locked")) {
      this.toggle.addEventListener("click", () => this.togglePanel());
    }
    this.radios.forEach((radio) => {
      radio.addEventListener("change", () => this.onSelect());
    });
    if (this.dismissBtn) {
      this.dismissBtn.addEventListener("click", () => this.close());
    }
    if (this.chooseBtn) {
      this.chooseBtn.addEventListener("click", () => this.addGift());
    }
  }

  togglePanel() {
    if (this.classList.contains("is-open")) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.classList.add("is-open");
    this.toggle?.setAttribute("aria-expanded", "true");
  }

  close() {
    this.classList.remove("is-open");
    this.toggle?.setAttribute("aria-expanded", "false");
  }

  onSelect() {
    const selected = this.querySelector("[data-loyalty-gwp-radio]:checked");
    if (this.chooseBtn) this.chooseBtn.disabled = !selected;
  }

  getSectionsToRequest() {
    return ["cart-drawer", "main-cart", "cart-bubble"];
  }

  addGift() {
    const selected = this.querySelector("[data-loyalty-gwp-radio]:checked");
    if (!selected) return;

    const variantId = selected.value;
    this.classList.add("is-loading");
    if (this.chooseBtn) this.chooseBtn.disabled = true;

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    formData.append("properties[_loyalty_gwp]", "true");
    formData.append("sections", this.getSectionsToRequest().join(","));
    formData.append("sections_url", window.location.pathname);

    fetch(theme.routes.cart_add_url, {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      body: formData,
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          this.classList.remove("is-loading");
          if (this.chooseBtn) this.chooseBtn.disabled = false;
          return;
        }

        dispatchCustomEvent("cart:item-added", {
          product: response.hasOwnProperty("items")
            ? response.items[0]
            : response,
        });
        dispatchCustomEvent("loyalty-gwp:added", { response });
        dispatchCustomEvent("line-item:change:end", {
          variantId,
          cart: response,
        });
      })
      .catch((e) => {
        this.classList.remove("is-loading");
        if (this.chooseBtn) this.chooseBtn.disabled = false;
        console.error(e);
      });
  }
}

if (!customElements.get("loyalty-gwp")) {
  customElements.define("loyalty-gwp", LoyaltyGwp);
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*",
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => video.pause());
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-localization-forms")
      .forEach((localization) => {
        localization.addEventListener("change", (e) => {
          const isCountry = e.target.name === "country_code";
          if (isCountry) {
            const selectedOption = e.target.querySelector(":checked");
            const selectedStore = selectedOption.dataset.store;
            const newUrl = new URL(
              selectedStore ? selectedStore : window.location.href,
            );
            newUrl.searchParams.set("country", selectedOption.value);
            return (window.location.href = newUrl.toString());
          }
          localization.querySelector("form").submit();
        });
      });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener("load", () => {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (
        e.target.matches(".resize-select") &&
        e.target.offsetParent !== null
      ) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener("resize.resize-select", function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement("option");
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement("select"),
      offset = 13;
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);
    if (
      sel.classList.contains("thb-language-code") ||
      sel.classList.contains("thb-currency-code") ||
      sel.classList.contains("facet-filters__sort")
    ) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== "undefined") {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    const accordion = event.currentTarget;
    const currentToggle = event.target.closest(".thb-widget-title");
    if (!currentToggle) return;

    const panelId = currentToggle.getAttribute("aria-controls");
    const currentPanel = accordion.querySelector(`#${panelId}`);
    const toggles = accordion.querySelectorAll(".thb-widget-title");
    const panels = accordion.querySelectorAll(".thb-widget-menu-wrapper");

    toggles.forEach((toggle) => {
      if (toggle !== currentToggle) {
        toggle.setAttribute("aria-expanded", false);
      }
    });
    panels.forEach((panel) => {
      if (panel === currentPanel) {
        const ariaState = currentToggle.getAttribute("aria-expanded");
        if (ariaState === "true") {
          currentToggle.setAttribute("aria-expanded", false);
          panel.classList.remove("is-open");
        } else {
          currentToggle.setAttribute("aria-expanded", true);
          panel.classList.add("is-open");
        }
      } else {
        panel.classList.remove("is-open");
      }
    });
  }
}
customElements.define("footer-menu-toggle", FooterMenuToggle);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;

      // this.addEventListener("click", this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML =
          sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.body.classList.add("open-quick-view");
        this.drawer.classList.add("active");

        this.drawer.querySelector(".side-panel-close").focus();

        setTimeout(() => {
          this.drawer
            .querySelector(".product-quick-images--container")
            .classList.add("active");
        });
        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define("quick-view", QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get("side-panel-content-tabs")) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll("button");
      this.panels = this.parentElement.querySelectorAll(
        ".side-panel-content--tab-panel",
      );
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {}
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove("tab-active");
      });
      this.buttons[i].classList.add("tab-active");

      this.panels.forEach((panel) => {
        panel.classList.remove("tab-active");
      });
      this.panels[i].classList.add("tab-active");
    }
  }

  customElements.define("side-panel-content-tabs", SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      const accordion = event.currentTarget;
      const currentToggle = event.target.closest(".accordion__summary");
      if (!currentToggle) return;
      const panelId = currentToggle.getAttribute("aria-controls");
      const currentPanel = accordion.querySelector(`#${panelId}`);
      const toggles = accordion.querySelectorAll(".accordion__summary");
      const panels = accordion.querySelectorAll(".accordion__content");

      toggles.forEach((toggle) => {
        if (toggle !== currentToggle) {
          toggle.setAttribute("aria-expanded", false);
        }
      });
      panels.forEach((panel) => {
        if (panel === currentPanel) {
          const ariaState = currentToggle.getAttribute("aria-expanded");
          if (ariaState === "true") {
            currentToggle.setAttribute("aria-expanded", false);
            panel.classList.remove("is-open");
          } else {
            currentToggle.setAttribute("aria-expanded", true);
            panel.classList.add("is-open");
          }
        } else {
          panel.classList.remove("is-open");
        }
      });
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector(".thb-product-detail");

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem(
      "recently-viewed",
      JSON.stringify(window.recentlyViewedIds),
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof Localization !== "undefined") {
    new Localization();
  }
  if (typeof CartDrawer !== "undefined") {
    new CartDrawer();
  }
  if (typeof Header !== "undefined") {
    new Header();
  }
  if (typeof FooterMenuToggle !== "undefined") {
    new FooterMenuToggle();
  }
});
